import { render, staticRenderFns } from "./cataloglist.vue?vue&type=template&id=21a27b9a&scoped=true"
import script from "./cataloglist.vue?vue&type=script&lang=js"
export * from "./cataloglist.vue?vue&type=script&lang=js"
import style0 from "./cataloglist.vue?vue&type=style&index=0&id=21a27b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a27b9a",
  null
  
)

export default component.exports